/**
 * @file コンポーネント：フル動画ページタイムライントピック スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledTopic = styled.li``;

export const StyledTopicButton = styled.button`
    width: 100%;
    padding: 8px 16px;
    border: none;
    background-color: transparent;
    color: #ffffff;
    text-align: left;

    &.is-active {
        background-color: #343a40;
    }
`;

export const StyledTopicComment = styled(StyledTopic)`
    position: relative;
    padding-left: 22.5px;

    &::before {
        position: absolute;
        top: 0;
        left: 20.5px;
        width: 2px;
        height: 100%;
        background-color: #6c757d;
        content: "";
    }

    &::after {
        position: absolute;
        top: 13px;
        left: 18.5px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #6c757d;
        content: "";
    }

    &.is-last {
        padding-bottom: 6px;
        border-bottom: 1px solid #6c757d;

        &::before {
            height: 16px;
        }
    }

    &.is-open {
        & > button,
        &::before,
        &::after {
            display: block;
        }
    }

    &.is-close {
        & > button,
        &::before,
        &::after {
            display: none;
        }
    }

    /* 未ログイン疑似最後：後半だけ点線 */
    &.is-locked-last {
        padding-bottom: 6px;
        border-bottom: 1px solid #6c757d;
    }

    &.is-locked-last::before {
        background:
            /* 上半分：通常の実線 */
            linear-gradient(
                to bottom,
                #6c757d 0%,
                #6c757d 70%,
                transparent 70%,
                transparent 100%
            ),
            /* 下半分：点線 */
            repeating-linear-gradient(
                to bottom,
                #6c757d 0px,
                #6c757d 2px,
                transparent 2px,
                transparent 8px
            );

        background-size:
            2px 90%,   /* 実線レイヤーは全高 */
            2px 90%;   /* 点線レイヤーも全高 */

        background-position:
            0 0,
            0 0;

        background-repeat: no-repeat;
    }
`;

export const StyledTopicHeader = styled(StyledTopic)`
    position: relative;
`;

export const StyledTopicHeaderTime = styled.div`
    margin-bottom: 8px;
    color: #7f97f8;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
`;

export const StyledTopicHeaderTitle = styled.div`
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;

    ${mediaQuery.pc(`
        font-size: 12px;
        line-height: 18px;
    `)};

    ${mediaQuery.pcWide(`
        font-size: 12px;
        line-height: 18px;
    `)};
`;

export const StyledTopicHeaderTitleText = styled.span``;

export const StyledTopicToggleButton = styled.button`
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    color: #999999;
    font-size: 20px;
    line-height: 32px;
    text-align: center;

    &:hover {
        color: #ffffff;
    }
`;
